import Vouchers from "@/components/Vouchers";

const VouchersPage = () => <Vouchers />;

export default VouchersPage;
